module.exports = __webpack_public_path__ + "b86310949af3eefa8af2f7a7413d4444.png";